import { render } from "./PagerComponent.vue?vue&type=template&id=754c1424"
import script from "./PagerComponent.vue?vue&type=script&lang=js"
export * from "./PagerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__